export function ScanPatientIcon() {
  return (
    <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M48.0729 51.9277H39.1813C38.6993 51.9277 38.3086 51.537 38.3086 51.0549C38.3086 50.5729 38.6993 50.1822 39.1813 50.1822H48.0729C49.236 50.1822 50.1822 49.236 50.1822 48.0729V39.1813C50.1822 38.6993 50.5729 38.3086 51.0549 38.3086C51.537 38.3086 51.9277 38.6993 51.9277 39.1813V48.0729C51.9277 50.1984 50.1984 51.9277 48.0729 51.9277Z"
        fill="black"
      />
      <path
        d="M51.0549 13.6191C50.5729 13.6191 50.1822 13.2284 50.1822 12.7464V3.85479C50.1822 2.69171 49.236 1.74545 48.0729 1.74545H39.1813C38.6993 1.74545 38.3086 1.35473 38.3086 0.872727C38.3086 0.39072 38.6993 0 39.1813 0H48.0729C50.1984 0 51.9277 1.72926 51.9277 3.85479V12.7464C51.9277 13.2284 51.537 13.6191 51.0549 13.6191Z"
        fill="black"
      />
      <path
        d="M0.872727 13.6191C0.39072 13.6191 0 13.2284 0 12.7464V3.85479C0 1.72926 1.72926 0 3.85479 0H12.7464C13.2284 0 13.6191 0.39072 13.6191 0.872727C13.6191 1.35473 13.2284 1.74545 12.7464 1.74545H3.85479C2.69171 1.74545 1.74545 2.69171 1.74545 3.85479V12.7464C1.74545 13.2284 1.35473 13.6191 0.872727 13.6191Z"
        fill="black"
      />
      <path
        d="M12.7464 51.9277H3.85479C1.72926 51.9277 0 50.1984 0 48.0729V39.1813C0 38.6993 0.39072 38.3086 0.872727 38.3086C1.35473 38.3086 1.74545 38.6993 1.74545 39.1813V48.0729C1.74545 49.236 2.69171 50.1822 3.85479 50.1822H12.7464C13.2284 50.1822 13.6191 50.5729 13.6191 51.0549C13.6191 51.537 13.2283 51.9277 12.7464 51.9277Z"
        fill="black"
      />
      <path
        d="M33.1276 35.9631C33.1276 34.1949 32.4252 32.4992 31.175 31.249C29.9247 29.9988 28.229 29.2964 26.4609 29.2964M26.4609 29.2964C24.6928 29.2964 22.9971 29.9988 21.7469 31.249C20.4966 32.4992 19.7943 34.1949 19.7943 35.9631M26.4609 29.2964C29.2224 29.2964 31.4609 27.0578 31.4609 24.2964C31.4609 21.535 29.2224 19.2964 26.4609 19.2964C23.6995 19.2964 21.4609 21.535 21.4609 24.2964C21.4609 27.0578 23.6995 29.2964 26.4609 29.2964ZM19.7943 9.29639V12.6297M33.1276 9.29639V12.6297M14.7943 12.6297H38.1276C39.9686 12.6297 41.4609 14.1221 41.4609 15.9631V39.2964C41.4609 41.1373 39.9686 42.6297 38.1276 42.6297H14.7943C12.9533 42.6297 11.4609 41.1373 11.4609 39.2964V15.9631C11.4609 14.1221 12.9533 12.6297 14.7943 12.6297Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M49.7455 25.6577H2.18189C1.82041 25.6577 1.52734 25.3647 1.52734 25.0032C1.52734 24.6417 1.82041 24.3486 2.18189 24.3486H49.7455C50.107 24.3486 50.4001 24.6417 50.4001 25.0032C50.4001 25.3647 50.107 25.6577 49.7455 25.6577Z"
        fill="#EF4444"
      />
    </svg>
  )
}
